import React, { useRef, useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Form, Input, Button, Row, Col, DatePicker, Select, message } from 'antd';
import moment from 'moment';

//import APIs
import { searchPayments } from '../../../services/payments/payments';
import { fetchCustomersListAPI } from 'services/shared/fetchLovList';


import '../payments.css'

//sample data
import data from './payment_sampleData';
import { RegexInput } from 'shared_components/pattern_input';
import { UserAccessContext } from 'context/userAccess';

const { Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

function SearchForm({ onFinish, onSearchStart, onSearchEnd }) {
	const { userAccess } = useContext(UserAccessContext);
	const navigate = useHistory();
	const formRef = useRef();
	const [loading, setLoading] = useState(false);
	const [customersList, setCustomersList] = useState([]);
	const [searchDisabled, setSearchDisabled] = useState(true);

	//sample data
	const [filterData, setFilterData] = useState(data);

	async function getLOVList(){
        try{
            const customers = await fetchCustomersListAPI();
            setCustomersList(customers);
        }catch(error) {
            console.log("error", error);
        }
    };

	useEffect(() => {
		function fetchData() {
			// setFilterData(data);
			getLOVList();
		}
		setLoading(true);
		fetchData();
		setLoading(false);
	}, []);



	async function handleSubmit(formValues) {
		try{
			if (onSearchStart) onSearchStart();
			const payments = await searchPayments(formValues);
			console.log('payments search', payments)
			onFinish(payments);

			if(payments.length <= 0){
				message.info('No results found');
			}
		}
		catch(error){
			throw error.message;
		} finally {
			if (onSearchEnd) onSearchEnd();
		}		
	}

	function onFocusReceiptNo() {
		// @ts-ignore
		const { setFieldsValue } = formRef.current;

		if(searchDisabled){
			setSearchDisabled(false);
		}

		//set values to undefined to clear the values being sent in API
		setFieldsValue({ payment_date: undefined, invoice_no: undefined, customer: undefined });
	}

	function onFocusPaymentDate(){
		// @ts-ignore
		const { setFieldsValue } = formRef.current;

		if(searchDisabled){
			setSearchDisabled(false);
		}

		setFieldsValue({ receipt_no: undefined });
	}

	function onFocusInvoiceNo(){
		// @ts-ignore
		const { setFieldsValue } = formRef.current;
		
		if(searchDisabled){
			setSearchDisabled(false);
		}
		
		setFieldsValue({ receipt_no: undefined });
	}

	function onFocusCustomer(){
		// @ts-ignore
		const { setFieldsValue } = formRef.current;
		
		if(searchDisabled){
			setSearchDisabled(false);
		}
		setFieldsValue({ receipt_no: undefined });
	}

	function clearSearch() {
		// @ts-ignore
		const { setFieldsValue } = formRef.current;		

		if(searchDisabled){
			setSearchDisabled(false);
		}

		//set values to undefined to clear the values being sent in API
		setFieldsValue({ 
			receipt_no: undefined, 
			payment_date: undefined, 
			invoice_no: undefined, 
			customer: undefined
		}); 
	}

	const disabledDate = (current) => {
		//limits future dates		
        return current > moment().endOf('day');
    };

	//customers LOV
	const customersOptions = customersList.map((item, index) => {
		return(
			<Option key={index} value={item.customer_id}>{item.customer}</Option>
		);
	})

	return (
		<div>
			<Form layout="vertical" onFinish={handleSubmit} ref={formRef} className='payment-search-form'>
				{/* invoice fields */}
				<Row gutter={[8, 1]} justify="space-around">
					<Col className="gutter-row" span={4}>
						<Form.Item label="O.R. NO." name="receipt_no">
							<RegexInput
								name="receipt_no"
								regex={/[a-zA-Z0-9]/}
								maxLength={50}
								placeholder="O.R. NO."
								onFocus={onFocusReceiptNo}
							/>
						</Form.Item>
					</Col>
					<Col span={1}>
                        <div style={{ marginLeft:5 ,marginRight:10, marginTop: 27 }}>
						{/* <div style={{ marginTop: 27 }}> */}
							<Text strong className="payment-filler-str">
								OR
							</Text>
						</div>
					</Col>
					<Col className="gutter-row" span={5}>
						<Form.Item label="PAYMENT DATE" name="payment_date">
							{/* <Input placeholder='INVOICE DATE'></Input> */}
							{/* @ts-ignore */}
							<RangePicker 
								format={'MM-DD-YYYY'} 
								onFocus={onFocusPaymentDate}
								disabledDate={disabledDate}
								/>
						</Form.Item>
					</Col>
					<Col className="gutter-row" span={5}>
						<Form.Item label="INVOICE NO." name="invoice_no">
							<RegexInput 
								placeholder="INVOICE NO." 
								name="invoice_no" 
								regex={/[a-zA-Z0-9]/}
								maxLength={50}
								onFocus={onFocusInvoiceNo}
								/>
						</Form.Item>						
					</Col>
					<Col className="gutter-row" span={9}>
						<Form.Item label="CUSTOMER" name="customer">
							<Select
								placeholder="CUSTOMER"
								showSearch
								filterOption={(input, option) =>
									option.children.toLowerCase().includes(input.toLowerCase())
								}
								onFocus={onFocusCustomer}
							>
								{customersOptions}
							</Select>
						</Form.Item>
					</Col>
				</Row>

				{/* buttons */}
				<Row gutter={[8, 1]} justify="end" align="bottom">
					<Col className="gutter-row">
						<Form.Item>
						<Button 
								className="login-form-button inv-button" 
								type="primary" 
								htmlType="submit"
								disabled={searchDisabled}
								>
								SEARCH
							</Button>
							<Button onClick={clearSearch}>CLEAR</Button>
						</Form.Item>
					</Col>
				</Row>
				{(userAccess['payments'].create === 'TRUE')
				?	<Row gutter={[8, 1]} justify="end" align="bottom">
						<Col className="gutter-row">
							<Form.Item>
								<Button
									// className="login-form-button inv-button-right"
									style={{ marginBottom: -5 }}
									type="primary"
									onClick={() => navigate.push('/payment/data_entry')}
								>
									ADD PAYMENT
								</Button>
							</Form.Item>
						</Col>
					</Row>
				:	<></>
				}
			</Form>
		</div>
	);
}

export default SearchForm;
